@if (tipoEstadoRonda) {
  <div id="tag-estado-ronda" class="px-3 py-1 d-flex align-items-center">
    <span class="p3-medium primary-900 mb-0">{{tipoEstadoRonda}}</span>
  </div>
}